<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/INTRO.mp4'

export default {
    name: 'intro-video',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/anita-hammer"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
